import { defineStore, acceptHMRUpdate } from 'pinia'

export const useUserStore = defineStore('user', {
  state: () => ({
    user_checked: false,
    user: null as null | { [key: string]: any },
    active_show: null,
    preferences: {} as { [key: string]: any },
    special_reports: null,

    user_check_error: null,

    chats_open: [],

    stores: {},
    fetching_stores: false,
    no_vendor_images: null,
  }),
  getters: {
    locale(state) {
      return state.preferences.locale || 'en-US'
    },
  },
  actions: {
    logout() {
      sessionStorage.removeItem('user')
      this.$patch({
        user_checked: true,
        user: null,
        preferences: {},
        special_reports: null,
      })
    },
    setUser(userData: any) {
      this.$patch({
        user_checked: true,
        user: userData.user,
        preferences: userData.preferences,
        special_reports: userData.special_reports,
      })
      this.persistToSessionStorage()
    },
    persistToSessionStorage() {
      sessionStorage.setItem(
        'user',
        JSON.stringify({
          user: this.$state.user,
          preferences: this.$state.preferences,
          special_reports: this.$state.special_reports,
          timestamp: new Date().getTime(),
        }),
      )
    },
    setLocale(locale: string) {
      this.$patch((state) => {
        state.preferences.locale = locale
      })
      this.persistToSessionStorage()
    },
    setStoresAndPermissions(payload: { [key: string]: any }) {
      this.$patch((state) => {
        if (state.user) {
          state.user.Stores = payload.enabled_stores
          state.user.Permissions = payload.permissions
          state.user.Store_Admin = payload.store_admin
        }
      })
      this.persistToSessionStorage()
    },
    async getUser() {
      const ex = sessionStorage.getItem('user')
      if (ex) {
        const u = JSON.parse(ex)
        if (u && new Date().getTime() - u.timestamp < 5 * 60000) {
          this.$patch({
            user_checked: true,
            user: u.user,
            preferences: u.preferences,
            special_reports: u.special_reports,
          })
          return Promise.resolve(true)
        }
      }
      const resp = await $fetch('/api/account/get-user').catch((err) => {
        const status = err.response.status || -1
        this.$patch({ user_checked: true, user_check_error: status })
        return Promise.resolve(false)
      })
      if (resp) {
        this.setUser(resp)
        return Promise.resolve(true)
      }
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUserStore, import.meta.hot))
}
